// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2o8iy","header":"MergedInvoice_header__7Mr7V"};